import styled from 'styled-components';


export const StyledInfoPanel = styled.div`


`;
